/**
 * The YubiKeys route tree — one screen, no nested detail route: a pool entry is five fields edited
 * in place (`YubikeysPage.tsx`), unlike a location's wider operational record.
 */
import type { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';

import { YubikeysPage } from './YubikeysPage.tsx';

export { yubikeysRoutePath } from './paths.ts';

export const YubikeysRouteTree = (): ReactElement => (
  <Routes>
    <Route path="/" element={<YubikeysPage />} />
  </Routes>
);
